import ApiService, { ApiArguments } from '@/api/api_service';
import {
  GetFollowUpPromptSetting200Response,
  GetTranscriptionSummaryPromptSetting200Response,
  PromptSettingApi,
  PromptSettingApiPutFollowUpPromptSettingRequest,
  PromptSettingApiPutTranscriptionSummaryPromptSettingRequest,
} from '@/api/openapi';

export class PromptSettingApiService extends ApiService {
  api = new PromptSettingApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getTranscriptionSummaryPromptSetting(
    {
      options,
      errorHandlers,
    }: ApiArguments<undefined>,
  ) {
    return this.checkResponse<GetTranscriptionSummaryPromptSetting200Response>(
      this.api.getTranscriptionSummaryPromptSetting(options),
      errorHandlers,
    );
  }

  async putTranscriptionSummaryPromptSetting({
    request,
    options,
    errorHandlers,
  }: ApiArguments<PromptSettingApiPutTranscriptionSummaryPromptSettingRequest>) {
    return this.checkResponse<void>(
      this.api.putTranscriptionSummaryPromptSetting(request, options),
      errorHandlers,
    );
  }

  async getFollowUpPromptSetting(
    {
      options,
      errorHandlers,
    }: ApiArguments<undefined>,
  ) {
    return this.checkResponse<GetFollowUpPromptSetting200Response>(
      this.api.getFollowUpPromptSetting(options),
      errorHandlers,
    );
  }

  async putFollowUpPromptSetting({
    request,
    options,
    errorHandlers,
  }: ApiArguments<PromptSettingApiPutFollowUpPromptSettingRequest>) {
    return this.checkResponse<void>(
      this.api.putFollowUpPromptSetting(request, options),
      errorHandlers,
    );
  }
}
